export const SIZE_SMALL = 'small'
export const SIZE_MEDIUM = 'medium'

export const ICON_SIZES = {
  [SIZE_MEDIUM]: 24,
  [SIZE_SMALL]: 19,
}
